<template>
        <div class="app-container">
           <section class="base-page container" >
           登录/注册
           </section>
        </div>
    </template>
    <script>
    
    
        export default {
        name: 'productList',
        computed: {
            
        },
        watch: {
        },
        components: {
           
        },
        data() {
            return {
            loading: false,
            }
        },
        mounted() {
        },
        beforeDestroy() {
            
        },
        methods: {
            
        }
        }
    
    </script>
    <style rel="stylesheet/scss" lang="scss">    
    /* .base-page.container {
        padding: vw(20);
    } */
    
    
    </style>


// WEBPACK FOOTER //
// src/components/login.vue